import Vue from "vue";
import App from "./components/App";
import router from "./router";
import store from "./store";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { extend, localize } from "vee-validate";
import ru from "vee-validate/dist/locale/ru";
import * as rules from "vee-validate/dist/rules";
import VueSkeletonLoader from 'skeleton-loader-vue';
import VueToastification from "vue-toastification";
import "vue-toastification/dist/index.css";

localize("ru", ru);

const needRules = [
  "required",
  "ext",
  "size",
  "min",
  "length",
  "email",
  "min_value",
  "max_value"
];

needRules.forEach(rule => {
  extend(rule, rules[rule]);
});
extend("required", {
  message: "Это обязательное поле"
});

extend("min_value", {
  params: ["min"],
  message: "Поле должно быть больше {min}"
});

extend("max_value", {
  params: ["max"],
  message: "Поле должно быть меньше {max}"
});
extend("password", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Пароли не совпадают"
});


Vue.config.productionTip = false;
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component('vue-skeleton-loader', VueSkeletonLoader);
Vue.use(VueToastification);

Vue.prototype.$copy = function(value) {
  navigator.clipboard.writeText(value);
};
new Vue({
  el: "#app",
  router,
  store,
  render: createElement => createElement(App)
});



// WEBPACK FOOTER //
// ./src/main.js